import { Cookies } from '../../../../utility/cookies';
import { FULL_SPA_MODE } from './cookieKeys';

const cookieBasedFeatureToggles = {
    isFullSpaModeEnabled: () => {
        const cookieValue = Cookies.read(FULL_SPA_MODE);
        return cookieValue === 'true';
    },

    enableFullSpaMode: (isEnabled: boolean) => {
        if (isEnabled) {
            Cookies.create(FULL_SPA_MODE, 'true'); // session cookie
        } else {
            Cookies.eraseCookie(FULL_SPA_MODE);
        }
    },
};

export default cookieBasedFeatureToggles;
